import {useEffect} from 'react'
import Anagraphic from './PgMakerComponent/Sheets/Anagraphic'
import SetAbility from './PgMakerComponent/Sheets/SetAbility'
import { CardDetail } from '../../element/Card'
import { useState } from 'react'
import { Tribe } from '../../List/TribeList'
import { auth } from '../../firebase/FirebaseConfig'
import {View} from 'react-native'
const PgModify = ({route}) => {
  const {item}= route.params
    const [name, setName] = useState(item.Name)
    const [sign, setSign] = useState(item.Sign)
    const [background, setBackground] = useState(item.Background)
    const [flip, setFlip]=useState(false)
   
  const Tribi=item.Tribe
  const usname=item.UserName
  
    const user= auth.currentUser


     
    

    

  return (
    <View style={{alignItems:'center', justifyContent:'center', paddingTop:20 }}>
    <CardDetail hsize={0.95} icon2={true} onPress1={()=>{setFlip(!flip)}} bottom={15} right={15}>
    {flip? <SetAbility Name={name} Background={background} Sign={sign} tribename={Tribe[Tribe.findIndex((obj)=>obj.name===Tribi)].name} triberule={Tribe[Tribe.findIndex((obj)=>obj.name===Tribi)].rule} id={item.Key} user={user.uid} userName={usname}/>:<Anagraphic value={name} onChangeText={(text)=>{setName(text)}} value1={background} onChangeText1={(text)=>{setBackground(text)}} value2={sign} onChangeText2={(text)=>{setSign(text)}} tribename={Tribe[Tribe.findIndex((obj)=>obj.name===Tribi)].name} tribeimage={Tribe[Tribe.findIndex((obj)=>obj.name===Tribi)].image}  />}
    </CardDetail>
    </View>
  )
}

export default PgModify

